import React, { useEffect, useState } from "react";
import ItemService from "../../../../services/commonService";
import "./DeviceConfigPage.scss";
import Constants from "../../../../common/Constants";

//Redux
import { useSelector } from "react-redux";

const DEVICE_CODE_KEY = "deviceCode";

const DeviceConfigPage = ({ user }) => {
  const [deviceCode, setDeviceCode] = useState("");
  const [savedDeviceCode, setSavedDeviceCode] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  let userData = useSelector((state) => state?.user); // User Details from Store

  //   const isAdmin = user?.role === "ADMIN";

  useEffect(() => {
    const existingCode = localStorage.getItem(DEVICE_CODE_KEY);

    if (existingCode) {
      setDeviceCode(existingCode);
      setSavedDeviceCode(existingCode);
    }
  }, []);

  const validateDeviceCode = () => {
    const code = deviceCode.trim();

    if (!code) {
      return "Device Code is required";
    }

    if (code.length < 6) {
      return "Device Code must be at least 6 characters";
    }

    if (!/^DEVTAB-[0-9]+$/i.test(code)) {
      return "Invalid format. Example: DEVTAB-1";
    }

    return "";
  };

  const handleSave = () => {
    setError("");
    setSuccess("");

    const validationError = validateDeviceCode();

    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      const finalCode = deviceCode.trim().toUpperCase();

      localStorage.setItem(DEVICE_CODE_KEY, finalCode);
      setSavedDeviceCode(finalCode);
      setDeviceCode(finalCode);
      setSuccess("Device configured successfully");
    } catch (err) {
      setError("Unable to save device code. Please try again.");
    }
  };

  const handleClear = () => {
    setError("");
    setSuccess("");

    localStorage.removeItem(DEVICE_CODE_KEY);
    setDeviceCode("");
    setSavedDeviceCode("");
    setSuccess("Device configuration removed");
  };

  const handleLogout = () => {
    let obj = { email: userData?.data?.email };
    ItemService.logout(obj).then((items) => {
      if (items?.status === 401) {
        window.location = Constants.LOGIN;
      } else {
        console.log(">> Please check the Network ");
      }
    });
  };

  return (
    <div className="device-control-page">
      <div className="animated-bg">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div className="device-card">
        <div className="device-icon">
          <span>📱</span>
        </div>

        <h1>Device Control</h1>
        <p className="subtitle">
          Configure TAB / Device used for QR Code login
        </p>

        {savedDeviceCode && (
          <div className="configured-box">
            <span>Configured Device</span>
            <strong>{savedDeviceCode}</strong>
          </div>
        )}

        <div className="input-group">
          <label>Device Code</label>
          <input
            type="text"
            value={deviceCode}
            placeholder="DEVTAB-1"
            onChange={(e) => {
              setDeviceCode(e.target.value);
              setError("");
              setSuccess("");
            }}
          />
        </div>

        <div className="example-box">
          <p>Example Device Codes</p>
          <div>
            <button type="button" onClick={() => setDeviceCode("DEVTAB-1")}>
              DEVTAB-1
            </button>
            <button type="button" onClick={() => setDeviceCode("DEVTAB-2")}>
              DEVTAB-2
            </button>
            <button type="button" onClick={() => setDeviceCode("DEVTAB-3")}>
              DEVTAB-3
            </button>
          </div>
        </div>

        {error && <div className="alert error">{error}</div>}
        {success && <div className="alert success">{success}</div>}

        <div className="action-row">
          <button className="save-btn" onClick={handleSave}>
            Save Device
          </button>

          {savedDeviceCode && (
            <button className="clear-btn" onClick={handleClear}>
              Clear
            </button>
          )}
        </div>
        <div className="action-row mt-4">
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeviceConfigPage;
